<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="text-sm-end d-none d-sm-block">
            Made with ❤︎ by Bus Booking Admin
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name:"footerUI"
}
</script>
